export type FeedbackReason = 
  | 'NOT_ENOUGH_TIME' 
  | 'FOUND_OTHER_PLACEMENT' 
  | 'TOO_DEMANDING' 
  | 'CHANGED_MIND' 
  | 'TECHNICAL_ISSUES' 
  | 'OTHER';

export interface ApplicationFeedback {
  _id: string;
  counsellor: string;
  counsellorEmail: string;
  counsellorName: string;
  reason?: FeedbackReason;
  reasonText?: string;
  wouldReapplyLater?: boolean;
  suggestions?: string;
  feedbackToken: string;
  feedbackTokenExpiry: Date;
  feedbackSubmitted: boolean;
  feedbackSubmittedDate?: Date;
  feedbackRequestSentDate: Date;
  applicationIssuedDate?: Date;
  applicationExpiryDate?: Date;
  applicationViewedInfo?: boolean;
  recruitmentCampaign?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface FeedbackFormData {
  reason: FeedbackReason | '';
  reasonText: string;
  wouldReapplyLater: boolean;
  suggestions: string;
}

export interface FeedbackStats {
  totalRequests: number;
  totalResponses: number;
  responseRate: string;
  reasonBreakdown: Record<FeedbackReason, number>;
  wouldReapplyLater: {
    count: number;
    percentage: string;
  };
}

export const FEEDBACK_REASON_LABELS: Record<FeedbackReason, string> = {
  NOT_ENOUGH_TIME: 'Not enough time to complete',
  FOUND_OTHER_PLACEMENT: 'Found another placement',
  TOO_DEMANDING: 'Application process too demanding',
  CHANGED_MIND: 'Changed my mind about applying',
  TECHNICAL_ISSUES: 'Technical issues with the form',
  OTHER: 'Other reason'
};
